<template>
  <b-card
    v-if="videoData"
    no-body
    class="data-total-area"
  >
    <div
      v-if="onProgress"
      class="data-loading d-flex justify-content-center"
    >
      <b-spinner
        class="mt-1"
        label="Loading"
      />
    </div>
    <b-card-body>
      <b-card-title>
        <b-row>
          <b-col class="col-10">
            Top Videos
          </b-col>
          <b-col
            v-if="videoData"
            class="col-2"
          >
            <b-link :to="{name:'project-frontend-dashboard-video-live'}">
              <feather-icon
                v-b-tooltip.hover
                width="18"
                height="18"
                icon="PlayCircleIcon"
                title="All Videos"
              />
            </b-link>
          </b-col>
        </b-row>
      </b-card-title>
      <b-row>
        <b-col
          class="d-flex col-2 align-items-center font-weight-bold"
          rowspan="2"
        />
        <b-col
          class="d-flex col-6 font-weight-bold"
        >
          Title
        </b-col>
        <b-col
          class="d-flex col-4 justify-content-center font-weight-bold"
        >
          Watching Now
        </b-col>
      </b-row>
      <b-row
        v-for="(item,index) in videoData"
        :key="`video-data-item-${index}`"
        class="d-flex justify-content-between mt-1"
        :class="index === videoData.length - 1 ? 'mb-0':'mb-1'"
      >
        <b-col
          class="d-flex col-2 align-items-center"
          rowspan="2"
        >
          <b-img
            v-if="item.videoPosterUrl"
            :src="item.videoPosterUrl"
            height="40px"
            width="40px"
          />
          <feather-icon
            v-else
            icon="VideoIcon"
            size="24"
          />
        </b-col>
        <b-col
          class="d-flex col-6"
        >
          {{ item.videoLabel ? item.videoLabel : item.videoId  }}
        </b-col>
        <b-col
          class="d-flex col-4 justify-content-center"
        >
          {{ item.pvCountLive ? item.pvCountLive.toLocaleString() : 'n/a' }}
        </b-col>
      </b-row>
      <b-col
        v-if="!videoData"
        class="d-flex col-12 justify-content-lg-start font-weight-bold mt-2"
      >
        <b-row>
          Video Data Not Available
        </b-row>
      </b-col>
    </b-card-body>
  </b-card>
</template>

<script>
import {
    BCard, BCardTitle, BCardBody, BSpinner, VBTooltip, BRow, BCol, BImg, BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { getCoreApiByObjectId } from '@/coreApi/coreApiHelper'

export default {
    components: {
        BCard,
        BCardTitle,
        BCardBody,
        BSpinner,
        BRow,
        BCol,
        BImg,
        BLink,
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    props: {
        dataObject: {
            type: Object,
            default: () => {},
        },
        onProgress: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            videoData: null,
        }
    },
    watch: {
        dataObject() {
            const object = getCoreApiByObjectId(this.dataObject, 'videoStatistics')
            let data = null
            if (
                object
                && object.data
                && object.data.at(-1)
            ) {
                data = object.data.at(-1)
            }
            if (data) {
                this.videoData = object.data
            } else {
                this.videoData = null
            }
        },
    },

}
</script>
<style>
.progress {
  border-radius: 5px;
}
</style>
